export const confirmationMappings = [
  { name: "Text", value: "Text" },
  { name: "Status", value: "Status" },
  { name: "Message", value: "Message" },
  { name: "Grouping", value: "Grouping" },
  { name: "Mapping", value: "Mapping" },
];
